import React from 'react';

/**
 * App-owned add-existing-food glyph. The stacked layers stand in for the
 * existing food catalog, and the separate plus makes the action legible
 * without relying on color.
 */
const FoodStackPlusIcon = ({ className = '' }) => (
  <svg
    data-icon="food-stack-plus"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path
      data-part="object"
      d="M9 4 3.5 7.5 9 11l5.5-3.5L9 4Z"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="currentColor"
      fillOpacity="0.38"
    />
    <path
      data-part="layer"
      d="M3.5 11.5 9 14.8l5.5-3.3"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      data-part="layer"
      d="M3.5 15 9 18.3l5.5-3.3"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      data-part="plus"
      d="M18.5 5v7M15 8.5h7"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
    />
  </svg>
);

export default FoodStackPlusIcon;
